import RegistrationOrigin from "../../Components/RegistrationOrigin";
import { getClassOptionLabel } from "../../utils/classPresentation";
import ClassPresentation from "../../Components/ClassPresentation";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaCamera, FaPlus, FaRegStar, FaStar, FaTrashAlt } from "react-icons/fa";
import { FiUserPlus, FiUsers } from "react-icons/fi";
import Swal from "sweetalert2";
import MenuLateral from "../../Components/MenuLateral";
import CadastroPageHeader, { CadastroPanelHeading } from "../../Components/CadastroPageHeader";
import api from "../../services/api";
import CepAddressLookup from "../../Components/CepAddressLookup";
import AuthenticatedMedia from "../../Components/AuthenticatedMedia";
import FieldLabel from "../../Components/FieldLabel";
import { showApiError } from "../../services/showApiError";
import {
  getPasswordStrength,
  isPasswordWithinPolicy,
  PASSWORD_POLICY_MESSAGE,
} from "../../auth/passwordPolicy";
import ReferencePhotoCropModal from "./ReferencePhotoCropModal";
import "./index.css";
import "../../styles/cadastro-pages.css";

const onlyDigits = (value = "") => value.replace(/\D/g, "");

const formatCpf = (value = "") => {
  const digits = onlyDigits(value).slice(0, 11);

  return digits
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
};

const formatPhone = (value = "") => {
  const digits = onlyDigits(value).slice(0, 11);

  if (digits.length <= 10) {
    return digits
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2");
  }

  return digits
    .replace(/^(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d)/, "$1-$2");
};

const normalizeDateForApi = (value = "") => {
  if (!value) return undefined;

  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return value;
  }

  const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

  if (match) {
    const [, day, month, year] = match;
    return `${year}-${month}-${day}`;
  }

  return value;
};

const getLinkedUserId = (student = {}) => student.userId || student.user?.id || "";

const getStudentAccessStatus = (student = {}) => {
  if (!getLinkedUserId(student)) {
    return "Sem conta";
  }

  if (student.status === "suspended") {
    return "Perfil suspenso";
  }

  const isAccountInactive = student.user?.status === false;
  const isProfileInactive = student.status === "inactive";

  if (isAccountInactive && isProfileInactive) {
    return "Conta e perfil inativos";
  }

  if (isAccountInactive) {
    return "Conta inativa";
  }

  if (isProfileInactive) {
    return "Perfil inativo";
  }

  return "Ativo";
};

const isIdentityConsolidationConflict = (error) =>
  error?.response?.status === 409 &&
  String(error?.response?.data?.message || "")
    .toLowerCase()
    .includes("identidade precisa ser consolidada");

const isInviteExpired = (invite = {}) => {
  const expiresAt = new Date(invite.expiresAt);

  return Number.isNaN(expiresAt.getTime()) || expiresAt <= new Date();
};

const formatInviteExpiration = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "data indisponível";
  }

  return new Intl.DateTimeFormat("pt-BR", {
    dateStyle: "long",
    timeStyle: "short",
  }).format(date);
};

function CadAlunoInt() {
  const navigate = useNavigate();
  const [id, setId] = useState("");
  const [registrationOrigin, setRegistrationOrigin] = useState();
  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [cpf, setCpf] = useState("");
  const [phone, setPhone] = useState("");
  const [nickname, setNickname] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [district, setDistrict] = useState("");
  const [city, setCity] = useState("");
  const [uf, setUf] = useState("");
  const [registrationNumber, setRegistrationNumber] = useState("");
  const [isFinancialResponsible, setIsFinancialResponsible] = useState(false);
  const [isBillingAddress, setIsBillingAddress] = useState(true);
  const [classRole, setClassRole] = useState("none");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  const [instituicoes, setInstituicoes] = useState([]);
  const [instModal, setInstModal] = useState(false);
  const [instQuery, setInstQuery] = useState("");
  const [selectedInstitution, setSelectedInstitution] = useState(null);

  const [turmas, setTurmas] = useState([]);
  const [turmaModal, setTurmaModal] = useState(false);
  const [turmaQuery, setTurmaQuery] = useState("");
  const [selectedClass, setSelectedClass] = useState(null);

  const podeEditarAluno = !!selectedClass;

  const [lista, setLista] = useState([]);
  const [gridSearch, setGridSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [studentDetailsLoading, setStudentDetailsLoading] = useState(false);
  const [photoActionLoading, setPhotoActionLoading] = useState(false);
  const [accountAction, setAccountAction] = useState(null);

  const [referencePhotos, setReferencePhotos] = useState([]);
  const [recognitionInfo, setRecognitionInfo] = useState(null);
  const [cropModalState, setCropModalState] = useState({
    isOpen: false,
    imageSrc: "",
    fileName: "",
    mimeType: "",
    action: null
  });

  const [invite, setInvite] = useState(null);
  const [inviteModal, setInviteModal] = useState(false);
  const [inviteLoading, setInviteLoading] = useState(false);
  const SITE_URL =
    process.env.REACT_APP_SITE_URL ||
    process.env.REACT_APP_URL_SITE ||
    window.location.origin;

  const [inviteValidityDays, setInviteValidityDays] = useState("30");

  const fileInputRef = useRef(null);
  const pendingFileActionRef = useRef(null);
  const accountActionLockRef = useRef(false);

  const aplicarEnderecoPorCep = (address) => {
    setStreet(address.street);
    setDistrict(address.district);
    setCity(address.city);
    setUf(address.uf);
  };

  const revokeIfBlobUrl = (value) => {
    if (typeof value === "string" && value.startsWith("blob:")) {
      URL.revokeObjectURL(value);
    }
  };

  const limparFotosLocais = (photos) => {
    (photos || []).forEach((photo) => {
      if (photo?.isPending) {
        revokeIfBlobUrl(photo.fileUrl);
      }
    });
  };

  const normalizarReferencePhotos = (photos = []) =>
    [...photos]
      .sort((left, right) => left.position - right.position)
      .map((photo) => ({
        id: photo.id,
        position: photo.position,
        isPrimary: !!photo.isPrimary,
        fileUrl: photo.fileUrl || null,
        mediaPath: photo.media?.path || null,
        originalName: photo.originalName,
        mimeType: photo.mimeType,
        sizeBytes: photo.sizeBytes,
        faceValidationStatus: photo.faceValidationStatus,
        faceValidationMessage: photo.faceValidationMessage,
        isPending: false
      }));

  const aplicarDetalheAluno = (student) => {
    limparFotosLocais(referencePhotos);
    const linkedUser = student.user || {};

    setId(student.id || "");
    setRegistrationOrigin(student.registrationOrigin);
    setUserId(student.userId || linkedUser.id || "");
    setName(linkedUser.name || student.name || "");
    setEmail(linkedUser.email || student.email || "");
    setCpf(formatCpf(linkedUser.cpf || student.cpf || ""));
    setPhone(formatPhone(linkedUser.phone || student.phone || ""));
    setNickname(linkedUser.nickname || student.nickname || "");
    setMobilePhone(formatPhone(linkedUser.mobilePhone || student.mobilePhone || ""));
    setBirthDate(linkedUser.birthDate || student.birthDate || "");
    setZipCode(linkedUser.zipCode || student.zipCode || "");
    setStreet(linkedUser.street || student.street || "");
    setNumber(linkedUser.number || student.number || "");
    setComplement(linkedUser.complement || student.complement || "");
    setDistrict(linkedUser.district || student.district || "");
    setCity(linkedUser.city || student.city || "");
    setUf(linkedUser.uf || student.uf || "");
    setRegistrationNumber(student.registrationNumber || "");
    setIsFinancialResponsible(!!student.isFinancialResponsible);
    setIsBillingAddress(student.isBillingAddress !== false);
    setClassRole(student.classRole || "none");
    setPassword("");
    setPasswordConfirmation("");
    setReferencePhotos(normalizarReferencePhotos(student.referencePhotos || []));

    setRecognitionInfo(null);
  };

  const carregarInstituicoes = async () => {
    try {
      const resp = await api.get("/institution");
      setInstituicoes(resp.data.institutions || []);
    } catch (err) {
      showApiError(err);
    }
  };

  const carregarTurmas = async (institutionId) => {
    try {
      const resp = await api.get("/class", {
        params: { institutionId }
      });
      setTurmas(resp.data.classes || []);
    } catch (err) {
      showApiError(err);
      setTurmas([]);
    }
  };

  const carregarAlunos = async () => {
    if (!selectedClass) return setLista([]);
    setLoading(true);
    try {
      const resp = await api.get("/students", {
        params: { classId: selectedClass.id }
      });
      setLista(resp.data.students || resp.data || []);
    } catch (err) {
      showApiError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarInstituicoes();
    // Esta carga ocorre apenas na montagem da pagina.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedInstitution) carregarTurmas(selectedInstitution.id);
    else setTurmas([]);
    // A instituicao selecionada e o gatilho completo desta carga.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedInstitution]);

  useEffect(() => {
    carregarAlunos();
    carregarConvite();
    // A turma selecionada e o gatilho completo destas cargas.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedClass]);

  const limpar = () => {
    setRegistrationOrigin(undefined);
    setId("");
    setUserId("");
    setName("");
    setEmail("");
    setCpf("");
    setPhone("");
    setNickname("");
    setMobilePhone("");
    setBirthDate("");
    setZipCode("");
    setStreet("");
    setNumber("");
    setComplement("");
    setDistrict("");
    setCity("");
    setUf("");
    setRegistrationNumber("");
    setIsFinancialResponsible(false);
    setIsBillingAddress(true);
    setClassRole("none");
    setPassword("");
    setPasswordConfirmation("");
    limparFotosLocais(referencePhotos);
    setReferencePhotos([]);
    setRecognitionInfo(null);
    setIsFormOpen(false);
  };

  const abrirCadastro = () => {
    limpar();
    setIsFormOpen(true);
  };

  const limparSelecaoTurma = () => {
    setSelectedClass(null);
    setTurmaQuery("");
    setLista([]);
    setGridSearch("");
    setInvite(null);
    limpar();
  };

  const carregarConvite = async () => {
    if (!selectedClass) {
      setInvite(null);
      return;
    }

    try {
      const resp = await api.get("/students/invites", {
        params: {
          classId: selectedClass.id,
          limit: 1,
        }
      });

      setInvite(resp.data.invites?.[0] || null);
    } catch (err) {
      showApiError(err, "Erro ao carregar convite");
      setInvite(null);
    }
  };

  const carregarDetalheAluno = async (studentId) => {
    setRegistrationOrigin(undefined);
    setStudentDetailsLoading(true);
    try {
      const resp = await api.get(`/students/${studentId}`);
      aplicarDetalheAluno(resp.data);
    } catch (err) {
      showApiError(err);
    } finally {
      setStudentDetailsLoading(false);
    }
  };

  const salvar = async () => {
    if (!selectedClass) {
      Swal.fire("Selecione a turma");
      return;
    }

    if (
      !name.trim() ||
      !email.trim() ||
      !cpf.trim() ||
      !phone.trim() ||
      !birthDate ||
      !zipCode.trim() ||
      !street.trim() ||
      !district.trim() ||
      !city.trim() ||
      !uf.trim()
    ) {
      Swal.fire(
        "Dados incompletos",
        "Preencha nome, CPF, email, telefone, nascimento e endereço para continuar.",
        "warning",
      );
      return;
    }

    if (!id && referencePhotos.length === 0) {
      Swal.fire(
        "Foto obrigatória",
        "Ao menos uma foto de referência é obrigatória para concluir o cadastro do aluno.",
        "warning"
      );
      return;
    }

    if (!id && (!password || !passwordConfirmation)) {
      Swal.fire(
        "Senha obrigatória",
        "Informe e confirme a senha do aluno autenticado.",
        "warning",
      );
      return;
    }

    if (!id && password !== passwordConfirmation) {
      Swal.fire(
        "Senhas não conferem",
        "A senha e a confirmação precisam ser iguais.",
        "warning",
      );
      return;
    }

    if (!id && !isPasswordWithinPolicy(password)) {
      Swal.fire("Senha inválida", PASSWORD_POLICY_MESSAGE, "warning");
      return;
    }

    setLoading(true);

    try {
      if (id) {
        const payloadUser = {
          name,
          email,
          cpf: onlyDigits(cpf),
          phone: onlyDigits(phone),
          nickname,
          mobilePhone: onlyDigits(mobilePhone),
          birthDate: normalizeDateForApi(birthDate),
          zipCode,
          street,
          number,
          complement,
          district,
          city,
          uf,
        };
        const payloadStudent = {
          registrationNumber,
          isFinancialResponsible,
          isBillingAddress,
          classRole,
        };

        await Promise.all([
          userId ? api.patch(`/users/${userId}`, payloadUser) : Promise.resolve(),
          api.patch(`/students/${id}`, payloadStudent),
        ]);

        Swal.fire("Atualizado!", "Aluno atualizado com sucesso", "success");
        await carregarDetalheAluno(id);
      } else {
        const payloadCreate = {
          name,
          email,
          cpf: onlyDigits(cpf),
          phone: onlyDigits(phone),
          nickname,
          mobilePhone: onlyDigits(mobilePhone),
          birthDate: normalizeDateForApi(birthDate),
          zipCode,
          street,
          number,
          complement,
          district,
          city,
          uf,
          role: "USER",
          password,
          passwordConfirmation,
          student: {
            classId: selectedClass.id,
            registrationNumber,
            isFinancialResponsible,
            isBillingAddress,
            classRole,
          },
        };

        const resp = await api.post("/users", payloadCreate);
        const studentId = resp.data?.user?.studentId;
        const orderedPhotos = [...referencePhotos].sort((a, b) => a.position - b.position);
        const preferredPrimary = orderedPhotos.find((photo) => photo.isPrimary);
        let lastOperationData = null;

        if (!studentId) {
          throw new Error("A API nao retornou o studentId para concluir o fluxo operacional.");
        }

        try {
          for (const photo of orderedPhotos) {
            lastOperationData = await enviarNovaFoto(studentId, photo.file, true);
          }

          if (preferredPrimary && lastOperationData?.referencePhotos?.length) {
            const savedPrimary = lastOperationData.referencePhotos.find(
              (photo) => photo.position === preferredPrimary.position
            );

            if (savedPrimary && !savedPrimary.isPrimary) {
              const primaryResp = await api.patch(
                `/students/${studentId}/reference-photos/${savedPrimary.id}/primary`
              );
              lastOperationData = primaryResp.data;
            }
          }
        } catch (uploadError) {
          throw uploadError;
        }

        if (lastOperationData?.recognition) {
          setRecognitionInfo(lastOperationData.recognition);
        } else {
          setRecognitionInfo(null);
        }

        Swal.fire("Cadastrado!", "Aluno cadastrado com sucesso", "success");
      }

      limpar();
      carregarAlunos();
    } catch (err) {
      showApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const selecionar = async (item) => {
    await carregarDetalheAluno(item.id);
    setIsFormOpen(true);
  };

  const executeWithIdentityConsolidation = async (student, mutation) => {
    const linkedUserId = getLinkedUserId(student);

    try {
      await mutation();
    } catch (error) {
      if (!isIdentityConsolidationConflict(error)) {
        throw error;
      }

      await api.post(`/users/${linkedUserId}/consolidate-identity`);
      await mutation();
    }
  };

  const inativar = async (student) => {
    const linkedUserId = getLinkedUserId(student);
    if (!linkedUserId || student.user?.status === false || accountActionLockRef.current) return;

    accountActionLockRef.current = true;
    setAccountAction({ studentId: student.id, type: "deactivate" });

    const confirm = await Swal.fire({
      title: "Inativar acesso do aluno?",
      text: "O cadastro do aluno sera preservado. Apenas o acesso da conta vinculada sera inativado.",
      icon: "warning",
      showCancelButton: true
    });
    if (!confirm.isConfirmed) {
      accountActionLockRef.current = false;
      setAccountAction(null);
      return;
    }

    try {
      await executeWithIdentityConsolidation(student, () =>
        api.delete(`/users/${linkedUserId}`),
      );

      await Swal.fire(
        "Acesso inativado",
        "O aluno foi preservado e a conta vinculada ficou inativa.",
        "success",
      );
      if (student.id === id) {
        limpar();
      }
    } catch (error) {
      showApiError(error, "Não foi possível inativar a conta");
    } finally {
      await carregarAlunos();
      accountActionLockRef.current = false;
      setAccountAction(null);
    }
  };

  const ativar = async (student) => {
    const linkedUserId = getLinkedUserId(student);
    const shouldActivateProfile = student.status === "inactive";
    const shouldActivateAccount = student.user?.status === false;

    if (
      !linkedUserId ||
      student.status === "suspended" ||
      (!shouldActivateProfile && !shouldActivateAccount) ||
      accountActionLockRef.current
    ) {
      return;
    }

    accountActionLockRef.current = true;
    setAccountAction({ studentId: student.id, type: "activate" });

    const confirm = await Swal.fire({
      title: "Ativar acesso do aluno?",
      text: "A conta e o perfil academico inativos serao reativados. O aluno precisara entrar novamente com a senha atual.",
      icon: "question",
      showCancelButton: true
    });
    if (!confirm.isConfirmed) {
      accountActionLockRef.current = false;
      setAccountAction(null);
      return;
    }

    try {
      if (shouldActivateProfile) {
        await executeWithIdentityConsolidation(student, () =>
          api.patch(`/students/${student.id}/status`, { status: "active" }),
        );
      }

      if (shouldActivateAccount) {
        await executeWithIdentityConsolidation(student, () =>
          api.patch(`/users/${linkedUserId}`, { status: true }),
        );
      }

      await Swal.fire(
        "Acesso ativado",
        "A conta e o perfil academico estao ativos. O aluno deve entrar novamente com a senha atual.",
        "success",
      );
      if (student.id === id) {
        limpar();
      }
    } catch (error) {
      showApiError(error, "Não foi possível concluir a ativação");
    } finally {
      // As duas mutacoes sao independentes. O reload revela uma eventual
      // ativacao parcial e permite repetir somente a etapa ainda pendente.
      await carregarAlunos();
      accountActionLockRef.current = false;
      setAccountAction(null);
    }
  };

  const enviarNovaFoto = async (studentId, file, silent = false) => {
    const formData = new FormData();
    formData.append("image", file);

    const resp = await api.post(`/students/${studentId}/reference-photos`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });

    if (!silent) {
      aplicarOperacaoFotos(resp.data);
    }

    return resp.data;
  };

  const substituirFoto = async (studentId, photoId, file) => {
    const formData = new FormData();
    formData.append("image", file);

    const resp = await api.put(
      `/students/${studentId}/reference-photos/${photoId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" }
      }
    );

    aplicarOperacaoFotos(resp.data);
    return resp.data;
  };

  const aplicarOperacaoFotos = (data) => {
    limparFotosLocais(referencePhotos);
    setReferencePhotos(normalizarReferencePhotos(data.referencePhotos || []));
    setRecognitionInfo(data.recognition || null);
  };

  const criarConvite = async () => {
    if (!selectedClass) return;

    const validityDays = Number(inviteValidityDays);

    if (!Number.isInteger(validityDays) || validityDays < 1) {
      Swal.fire(
        "Validade inválida",
        "Informe uma quantidade inteira de dias maior que zero.",
        "warning",
      );
      return;
    }

    setInviteLoading(true);

    try {
      const payload = {
        classId: selectedClass.id,
        validityDays,
      };

      const resp = await api.post("/students/invites", payload);

      setInvite(resp.data.invite);
      setInviteModal(false);

      Swal.fire("Criado!", "Link de cadastro gerado com sucesso.", "success");
    } catch (err) {
      showApiError(err);
    } finally {
      setInviteLoading(false);
    }
  };

  const instituicoesFiltradas = instituicoes.filter((item) => {
    const q = instQuery.trim().toLowerCase();
    if (!q) return true;

    return (
      (item.name || "").toLowerCase().includes(q) ||
      (item.city || "").toLowerCase().includes(q) ||
      (item.uf || "").toLowerCase().includes(q)
    );
  });

  const turmasFiltradas = turmas.filter((item) => {
    const q = turmaQuery.trim().toLowerCase();
    if (!q) return true;

    return (
      getClassOptionLabel(item).toLowerCase().includes(q) ||
      String(item.graduationYear || "").toLowerCase().includes(q)
    );
  });

  const abrirModalInstituicoes = async () => {
    setInstQuery("");
    setInstModal(true);
    await carregarInstituicoes();
  };

  const abrirModalTurmas = async () => {
    if (!selectedInstitution) return;
    setTurmaQuery("");
    setTurmaModal(true);
    await carregarTurmas(selectedInstitution.id);
  };

  const selecionarInstituicao = (item) => {
    const mudouInstituicao = selectedInstitution?.id !== item.id;
    setSelectedInstitution(item);
    setInstModal(false);

    if (mudouInstituicao) {
      limparSelecaoTurma();
    }
  };

  const selecionarTurma = (item) => {
    setSelectedClass(item);
    setTurmaModal(false);
    setGridSearch("");
    limpar();
  };

  const abrirSeletorArquivo = (action) => {
    if (!podeEditarAluno || photoActionLoading) return;

    if (action.type === "add" && referencePhotos.length >= 3) {
      Swal.fire("Limite atingido", "O aluno já possui 3 fotos de referência.", "info");
      return;
    }

    pendingFileActionRef.current = action;

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
      fileInputRef.current.click();
    }
  };

  const handleFileSelected = (event) => {
    const file = event.target.files?.[0];
    const action = pendingFileActionRef.current;

    if (!file || !action) return;

    if (!file.type?.startsWith("image/")) {
      Swal.fire("Arquivo inválido", "Selecione uma imagem válida para continuar.", "warning");
      return;
    }

    setCropModalState({
      isOpen: true,
      imageSrc: URL.createObjectURL(file),
      fileName: file.name,
      mimeType: file.type,
      action
    });
  };

  const fecharCropModal = () => {
    revokeIfBlobUrl(cropModalState.imageSrc);
    setCropModalState({
      isOpen: false,
      imageSrc: "",
      fileName: "",
      mimeType: "",
      action: null
    });
  };

  const confirmarCrop = async (croppedFile, cropError) => {
    if (cropError) {
      showApiError(cropError);
      return;
    }

    const action = cropModalState.action;
    if (!croppedFile || !action) return;

    setPhotoActionLoading(true);

    try {
      if (id) {
        if (action.type === "add") {
          await enviarNovaFoto(id, croppedFile);
        } else if (action.type === "replace") {
          await substituirFoto(id, action.photoId, croppedFile);
        }
      } else {
        const localPreviewUrl = URL.createObjectURL(croppedFile);

        setReferencePhotos((current) => {
          const sorted = [...current].sort((a, b) => a.position - b.position);

          if (action.type === "replace") {
            return sorted.map((photo) => {
              if (photo.id !== action.photoId) return photo;
              revokeIfBlobUrl(photo.fileUrl);
              return {
                ...photo,
                file: croppedFile,
                fileUrl: localPreviewUrl,
                originalName: croppedFile.name
              };
            });
          }

          const usedPositions = new Set(sorted.map((photo) => photo.position));
          const position = [1, 2, 3].find((candidate) => !usedPositions.has(candidate)) || 1;
          const isPrimary = sorted.length === 0;

          return [
            ...sorted,
            {
              id: `temp-${Date.now()}-${Math.random().toString(36).slice(2)}`,
              position,
              isPrimary,
              file: croppedFile,
              fileUrl: localPreviewUrl,
              originalName: croppedFile.name,
              isPending: true
            }
          ].sort((left, right) => left.position - right.position);
        });
      }

      fecharCropModal();
    } catch (err) {
      showApiError(err);
    } finally {
      setPhotoActionLoading(false);
    }
  };

  const marcarComoPrincipal = async (photo) => {
    if (photo.isPrimary || photoActionLoading) return;

    if (!id) {
      setReferencePhotos((current) =>
        current.map((item) => ({
          ...item,
          isPrimary: item.id === photo.id
        }))
      );
      return;
    }

    try {
      setPhotoActionLoading(true);
      const resp = await api.patch(`/students/${id}/reference-photos/${photo.id}/primary`);
      limparFotosLocais(referencePhotos);
      setReferencePhotos(normalizarReferencePhotos(resp.data.referencePhotos || []));
    } catch (err) {
      showApiError(err);
    } finally {
      setPhotoActionLoading(false);
    }
  };

  const removerFoto = async (photo) => {
    if (photoActionLoading) return;

    const confirm = await Swal.fire({
      title: "Remover foto de referência?",
      icon: "warning",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    if (!id) {
      setReferencePhotos((current) => {
        const filtered = current.filter((item) => item.id !== photo.id);
        revokeIfBlobUrl(photo.fileUrl);

        if (filtered.length > 0 && !filtered.some((item) => item.isPrimary)) {
          const nextPrimary = [...filtered].sort((a, b) => a.position - b.position)[0];
          return filtered.map((item) => ({
            ...item,
            isPrimary: item.id === nextPrimary.id
          }));
        }

        return filtered;
      });
      return;
    }

    try {
      setPhotoActionLoading(true);
      const resp = await api.delete(`/students/${id}/reference-photos/${photo.id}`);
      aplicarOperacaoFotos(resp.data);
    } catch (err) {
      showApiError(err);
    } finally {
      setPhotoActionLoading(false);
    }
  };

  const instituicoesFiltradasRef = instituicoesFiltradas;
  const turmasFiltradasRef = turmasFiltradas;
  const listaFiltrada = lista.filter((item) =>
    (item.name || "").toLowerCase().includes(gridSearch.trim().toLowerCase()),
  );
  const referencePhotosOrdenadas = useMemo(
    () => [...referencePhotos].sort((a, b) => a.position - b.position),
    [referencePhotos]
  );
  const photoCount = referencePhotosOrdenadas.length;
  const inviteExpired = invite ? isInviteExpired(invite) : false;
  return (
    <div className="pagina-cad cadastro-shell cadastro-shell-alunos">
      <MenuLateral />

      <div className="conteudo-cad">
        <CadastroPageHeader
          eyebrow="Cadastros / Pessoas"
          title="Alunos"
          description="Cadastre a pessoa, o perfil acadêmico e as referências necessárias para a operação."
          icon={FiUsers}
          context="Perfis acadêmicos"
          contextDetail="Pessoa, acesso e turma no mesmo fluxo"
        />

        <div className="selecao-cards">
          <div className={`card-selecao ${selectedInstitution ? "ativo" : ""}`}>
            <div className="card-info">
              <span className="card-label">Instituição</span>
              <strong>{selectedInstitution?.name || "Nenhuma selecionada"}</strong>
              {selectedInstitution && (
                <small>
                  {selectedInstitution.city} - {selectedInstitution.uf}
                </small>
              )}
            </div>

            <button onClick={abrirModalInstituicoes}>
              {selectedInstitution ? "Trocar" : "Selecionar"}
            </button>
          </div>

          <div className={`card-selecao ${selectedClass ? "ativo" : "desabilitado"}`}>
            <div className="card-info">
              <span className="card-label">Turma</span>
              <ClassPresentation schoolClass={selectedClass} fallback="Nenhuma selecionada" />
              {selectedClass && <small>Ano: {selectedClass.graduationYear}</small>}
            </div>

            <button disabled={!selectedInstitution} onClick={abrirModalTurmas}>
              {selectedClass ? "Trocar" : "Selecionar"}
            </button>
          </div>
        </div>

        {selectedClass && (
          <div className="convite-box">
            {invite && !inviteExpired ? (
              <>
                <span>Link de cadastro para alunos:</span>

                <div className="convite-link">
                  <input readOnly value={`${SITE_URL}/CadAlunoExt/${invite.token}`} />
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(`${SITE_URL}/CadAlunoExt/${invite.token}`);
                      Swal.fire("Copiado!", "Link copiado para a área de transferência", "success");
                    }}
                  >
                    Copiar
                  </button>
                </div>
                <small className="form-help">
                  Válido até {formatInviteExpiration(invite.expiresAt)}.
                </small>
              </>
            ) : (
              <>
                {inviteExpired && (
                  <p className="form-help mb-2">
                    O último link expirou em {formatInviteExpiration(invite.expiresAt)}. Gere um novo convite para abrir outro período de cadastro.
                  </p>
                )}
                <button className="btn-convite" onClick={() => setInviteModal(true)}>
                  Gerar link de cadastro externo
                </button>
              </>
            )}
          </div>
        )}

        {selectedClass && !isFormOpen && (
          <div className="cad-aluno-actions">
            <button type="button" onClick={abrirCadastro} disabled={loading || studentDetailsLoading}>
              Adicionar +
            </button>
          </div>
        )}

        {isFormOpen && (
          <>
        <div className="form-cad">
          <CadastroPanelHeading
            eyebrow={id ? "Edição de cadastro" : "Novo cadastro"}
            title={id ? "Atualizar aluno" : "Adicionar aluno"}
            description="Complete os dados por etapa e mantenha pelo menos uma foto de referência válida."
            icon={id ? FiUsers : FiUserPlus}
          />
          <div className="form-section-title">Pessoa</div>
          <FieldLabel label="Nome">
            <input
              placeholder="Nome"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
            />
          </FieldLabel>
          <FieldLabel label="Apelido">
            <input
              placeholder="Apelido"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
            />
          </FieldLabel>
          <div className="row-dates">
            <FieldLabel label="E-mail">
              <input
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
            <FieldLabel label="CPF">
              <input
                placeholder="CPF"
                value={cpf}
                onChange={(e) => setCpf(formatCpf(e.target.value))}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
          </div>
          <div className="row-dates">
            <FieldLabel label="Telefone">
              <input
                placeholder="Telefone"
                value={phone}
                onChange={(e) => setPhone(formatPhone(e.target.value))}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
            <FieldLabel label="Celular">
              <input
                placeholder="Celular"
                value={mobilePhone}
                onChange={(e) => setMobilePhone(formatPhone(e.target.value))}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
          </div>
          <div className="row-dates">
            <FieldLabel label="Data de nascimento">
              <input
                type="date"
                placeholder="Data de nascimento"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
            <CepAddressLookup
              address={{ zipCode, street, number, complement, district, city, uf }}
              onZipCodeChange={setZipCode}
              onApplyAddress={aplicarEnderecoPorCep}
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
            />
          </div>
          <div className="row-dates">
            <FieldLabel label="Logradouro">
              <input
                placeholder="Logradouro"
                value={street}
                onChange={(e) => setStreet(e.target.value)}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
            <FieldLabel label="Número">
              <input
                placeholder="Número"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
          </div>
          <div className="row-dates">
            <FieldLabel label="Complemento">
              <input
                placeholder="Complemento"
                value={complement}
                onChange={(e) => setComplement(e.target.value)}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
            <FieldLabel label="Bairro">
              <input
                placeholder="Bairro"
                value={district}
                onChange={(e) => setDistrict(e.target.value)}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
          </div>
          <div className="row-dates">
            <FieldLabel label="Cidade">
              <input
                placeholder="Cidade"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
            <FieldLabel label="UF">
              <input
                placeholder="UF"
                maxLength="2"
                value={uf}
                onChange={(e) => setUf(e.target.value.toUpperCase())}
                disabled={!podeEditarAluno || loading || studentDetailsLoading}
              />
            </FieldLabel>
          </div>

          {!id && (
            <>
              <div className="form-section-title">Conta de acesso</div>
              <div className="row-dates">
                <FieldLabel label="Senha inicial">
                  <input
                    type="password"
                    placeholder="Senha inicial"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={!podeEditarAluno || loading || studentDetailsLoading}
                  />
                </FieldLabel>
                <FieldLabel label="Confirmar senha">
                  <input
                    type="password"
                    placeholder="Confirmar senha"
                    value={passwordConfirmation}
                    onChange={(e) => setPasswordConfirmation(e.target.value)}
                    disabled={!podeEditarAluno || loading || studentDetailsLoading}
                  />
                </FieldLabel>
              </div>
              <small className="form-help">
                {getPasswordStrength(password)
                  ? `Força da senha: ${getPasswordStrength(password)}.`
                  : PASSWORD_POLICY_MESSAGE}
              </small>
            </>
          )}

          <div className="cad-aluno-academic-heading">
            <div className="form-section-title">Perfil acadêmico do aluno</div>
            {id && !studentDetailsLoading && <RegistrationOrigin value={registrationOrigin} />}
          </div>
          <FieldLabel label="Matrícula">
            <input
              placeholder="Matrícula"
              value={registrationNumber}
              onChange={(e) => setRegistrationNumber(e.target.value)}
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
            />
          </FieldLabel>
          <FieldLabel label="Cargo na turma">
            <select
              value={classRole}
              onChange={(e) => setClassRole(e.target.value)}
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
              style={{ height: "35px" }}
            >
              <option value="none">Nenhum cargo</option>
              <option value="treasurer">Tesoureiro</option>
              <option value="president">Presidente</option>
            </select>
          </FieldLabel>
          <label className="form-check-line">
            <input
              type="checkbox"
              checked={isFinancialResponsible}
              onChange={(e) => setIsFinancialResponsible(e.target.checked)}
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
            />
            É responsável financeiro
          </label>
          <label className="form-check-line">
            <input
              type="checkbox"
              checked={isBillingAddress}
              onChange={(e) => setIsBillingAddress(e.target.checked)}
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
            />
            Endereço informado é de cobrança
          </label>

          <div className="botoes">
            <button disabled={!podeEditarAluno || loading || studentDetailsLoading} onClick={salvar}>
              {id ? "Atualizar" : "Salvar"}
            </button>
            <button
              disabled={!podeEditarAluno || loading || studentDetailsLoading}
              className="btn-limpar"
              onClick={limpar}
            >
              Limpar
            </button>
          </div>
        </div>

        <div className="reference-section">
          <div className="reference-header">
            <div>
              <h3>Fotos de referência</h3>
              <p className="reference-counter">{photoCount}/3 foto(s)</p>
            </div>

            <button
              type="button"
              onClick={() => abrirSeletorArquivo({ type: "add" })}
              disabled={!podeEditarAluno || photoActionLoading || photoCount >= 3}
            >
              <FaPlus />
              Adicionar foto
            </button>
          </div>

          <div className="reference-help">
            Envie apenas a foto ou a parte da imagem em que apareça somente o rosto do aluno. Se a foto tiver várias pessoas, recorte manualmente antes de subir.
          </div>

          {recognitionInfo && (
            <div className={`recognition-banner ${recognitionInfo.status || "failed"}`}>
              {recognitionInfo.message}
            </div>
          )}

          {photoCount === 0 ? (
            <div className="primary-preview-empty">
              Nenhuma foto de referência adicionada ainda. Para concluir um novo cadastro, é obrigatório subir pelo menos uma foto.
            </div>
          ) : null}

          <div className="reference-grid">
            {referencePhotosOrdenadas.map((photo) => (
              <div key={photo.id} className={`reference-card ${photo.isPrimary ? "is-primary" : ""}`}>
                <div className="reference-media">
                  {photo.fileUrl ? (
                    <img src={photo.fileUrl} alt={`Foto de referência ${photo.position}`} />
                  ) : photo.mediaPath ? (
                    <AuthenticatedMedia path={photo.mediaPath} alt={`Foto de referência ${photo.position}`} />
                  ) : (
                    <div className="reference-protected-media">Imagem protegida</div>
                  )}
                  <button
                    type="button"
                    className={`star-toggle ${photo.isPrimary ? "active" : ""}`}
                    onClick={() => marcarComoPrincipal(photo)}
                    disabled={!podeEditarAluno || photoActionLoading}
                    title={photo.isPrimary ? "Foto principal" : "Definir como principal"}
                  >
                    {photo.isPrimary ? <FaStar /> : <FaRegStar />}
                  </button>
                </div>

                <div className="reference-info">
                  {photo.isPrimary ? <span className="reference-status">Principal</span> : null}
                  {photo.isPending && <small>Pendente de envio</small>}
                  {["INVALID", "UNAVAILABLE"].includes(photo.faceValidationStatus) ? (
                    <small className="reference-face-alert">
                      {photo.faceValidationMessage || "Esta referencia precisa ser substituida para melhorar o reconhecimento."}
                    </small>
                  ) : null}
                </div>

                <div className="reference-actions">
                  <button
                    type="button"
                    onClick={() => abrirSeletorArquivo({ type: "replace", photoId: photo.id })}
                    disabled={!podeEditarAluno || photoActionLoading}
                  >
                    <FaCamera />
                    Trocar
                  </button>
                  <button
                    type="button"
                    className="btn-excluir"
                    onClick={() => removerFoto(photo)}
                    disabled={!podeEditarAluno || photoActionLoading}
                  >
                    <FaTrashAlt />
                    Remover
                  </button>
                </div>
              </div>
            ))}

            {podeEditarAluno && photoCount < 3 && (
              <button
                type="button"
                className="reference-add-card"
                onClick={() => abrirSeletorArquivo({ type: "add" })}
                disabled={photoActionLoading}
              >
                <FaPlus />
                <span>Adicionar nova foto</span>
              </button>
            )}
          </div>
        </div>
          </>
        )}

        <section className="cadastro-list-panel" aria-labelledby="alunos-list-title">
        <div className="cadastro-list-heading">
          <div>
            <span className="cadastro-list-kicker">Base acadêmica</span>
            <h2 id="alunos-list-title">Alunos da turma</h2>
            <p>Consulte o cadastro, abra o perfil e ajuste o acesso quando necessário.</p>
          </div>
          <span className="cadastro-list-count">{listaFiltrada.length} {listaFiltrada.length === 1 ? "item" : "itens"}</span>
        </div>

        <div className="grid-toolbar">
          <FieldLabel label="Buscar por nome">
            <input
              className="grid-search-input"
              type="text"
              placeholder="Buscar por nome"
              value={gridSearch}
              onChange={(e) => setGridSearch(e.target.value)}
              disabled={!selectedClass}
            />
          </FieldLabel>
        </div>

        <div className="cadastro-table-wrap">
        <table className="grid-cad">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Email</th>
              <th>CPF</th>
              <th>Matrícula</th>
              <th>Situação</th>
              <th width="200">Ações</th>
            </tr>
          </thead>
          <tbody>
            {listaFiltrada.map((a) => {
              const accessStatus = getStudentAccessStatus(a);
              const canDeactivateAccount =
                Boolean(getLinkedUserId(a)) &&
                a.user?.status !== false &&
                a.status !== "inactive";
              const canActivate = [
                "Conta inativa",
                "Perfil inativo",
                "Conta e perfil inativos",
              ].includes(accessStatus);
              const isThisActionLoading = accountAction?.studentId === a.id;
              const isAnyAccountActionLoading = accountAction !== null;

              let actionLabel = "Inativar";
              if (isThisActionLoading) {
                actionLabel = accountAction.type === "activate" ? "Ativando..." : "Inativando...";
              } else if (canActivate) {
                actionLabel = "Ativar";
              } else if (accessStatus === "Sem conta") {
                actionLabel = "Sem conta";
              } else if (accessStatus === "Perfil suspenso" && a.user?.status === false) {
                actionLabel = "Perfil suspenso";
              }

              return (
              <tr key={a.id}>
                <td>{a.name}</td>
                <td>{a.email}</td>
                <td>{formatCpf(a.cpf || "") || "-"}</td>
                <td>{a.registrationNumber}</td>
                <td>{accessStatus}</td>
                <td className="grid-actions">
                  <button onClick={() => selecionar(a)} disabled={studentDetailsLoading}>
                    {studentDetailsLoading && id === a.id ? "Carregando..." : "Editar"}
                  </button>
                  <button onClick={() => navigate(`/Aluno/Perfil/${a.id}`)} disabled={studentDetailsLoading}>
                    Perfil
                  </button>
                  <button
                    className="btn-excluir"
                    onClick={() => (canActivate ? ativar(a) : inativar(a))}
                    disabled={
                      (!canDeactivateAccount && !canActivate) ||
                      isAnyAccountActionLoading ||
                      loading ||
                      studentDetailsLoading
                    }
                  >
                    {actionLabel}
                  </button>
                </td>
              </tr>
              );
            })}
            {listaFiltrada.length === 0 && !loading && (
              <tr>
                <td colSpan="6">Nenhum aluno encontrado para a turma selecionada.</td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
        </section>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        hidden
        onChange={handleFileSelected}
      />

      <ReferencePhotoCropModal
        isOpen={cropModalState.isOpen}
        imageSrc={cropModalState.imageSrc}
        fileName={cropModalState.fileName}
        mimeType={cropModalState.mimeType}
        busy={photoActionLoading}
        onClose={fecharCropModal}
        onConfirm={confirmarCrop}
      />

      {instModal && (
        <div className="modal-overlay" onClick={() => setInstModal(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h3>Selecione a Instituição</h3>
                <div className="modal-subtitle">
                  Escolha a instituição antes de selecionar a turma.
                </div>
              </div>
              <button className="modal-close" onClick={() => setInstModal(false)}>
                ×
              </button>
            </div>

            <div className="modal-body">
              <FieldLabel label="Buscar instituição">
                <input
                  type="text"
                  placeholder="Buscar instituição por nome, cidade ou UF"
                  value={instQuery}
                  onChange={(e) => setInstQuery(e.target.value)}
                  className="modal-search"
                />
              </FieldLabel>

              <div className="modal-list">
                {instituicoesFiltradasRef.length === 0 ? (
                  <div className="modal-empty">Nenhuma instituição encontrada.</div>
                ) : (
                  instituicoesFiltradasRef.map((item) => (
                    <div
                      key={item.id}
                      className="modal-item"
                      onClick={() => selecionarInstituicao(item)}
                    >
                      <div className="modal-item-left">
                        <strong>{item.name}</strong>
                        <small>
                          {item.city} - {item.uf}
                        </small>
                      </div>
                      <button type="button" className="modal-item-action-button">
                        Selecionar
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {turmaModal && (
        <div className="modal-overlay" onClick={() => setTurmaModal(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h3>Selecione a Turma</h3>
                <div className="modal-subtitle">
                  Escolha a turma para cadastrar ou editar alunos.
                </div>
              </div>
              <button className="modal-close" onClick={() => setTurmaModal(false)}>
                ×
              </button>
            </div>

            <div className="modal-body">
              <FieldLabel label="Buscar turma">
                <input
                  type="text"
                  placeholder="Buscar turma por nome ou ano"
                  value={turmaQuery}
                  onChange={(e) => setTurmaQuery(e.target.value)}
                  className="modal-search"
                />
              </FieldLabel>

              <div className="modal-list">
                {turmasFiltradasRef.length === 0 ? (
                  <div className="modal-empty">Nenhuma turma encontrada.</div>
                ) : (
                  turmasFiltradasRef.map((item) => (
                    <div
                      key={item.id}
                      className="modal-item"
                      onClick={() => selecionarTurma(item)}
                    >
                      <div className="modal-item-left">
                        <ClassPresentation schoolClass={item} />
                        <small>Ano de formatura: {item.graduationYear}</small>
                      </div>
                      <button type="button" className="modal-item-action-button">
                        Selecionar
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {inviteModal && (
        <div className="modal-overlay" onClick={() => setInviteModal(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div>
                <h3>Criar link de cadastro externo</h3>
                <div className="modal-subtitle">
                  Defina por quantos dias o link ficará disponível.
                </div>
              </div>
              <button className="modal-close" onClick={() => setInviteModal(false)}>
                ×
              </button>
            </div>

            <div className="modal-body">
              <div className="form-cad">
                <div className="invite-field-label">
                  <small className="form-help">
                    Pessoas distintas podem usar este mesmo link enquanto ele estiver válido.
                  </small>
                </div>
                <FieldLabel label="Validade do link (em dias)">
                  <input
                    id="invite-validity-days"
                    type="number"
                    min="1"
                    placeholder="Quantidade de dias"
                    value={inviteValidityDays}
                    onChange={(e) => setInviteValidityDays(e.target.value)}
                  />
                </FieldLabel>

                <div className="botoes">
                  <button onClick={criarConvite} disabled={inviteLoading}>
                    {inviteLoading ? "Criando..." : "Criar convite"}
                  </button>
                  <button
                    className="btn-limpar"
                    onClick={() => setInviteModal(false)}
                    disabled={inviteLoading}
                  >
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CadAlunoInt;
